// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminController from "./admin_controller"
application.register("admin", AdminController)

import AdminDatatableController from "./admin_datatable_controller"
application.register("admin-datatable", AdminDatatableController)

import ClientAppController from "./client_app_controller"
application.register("client-app", ClientAppController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConsultantFormController from "./consultant_form_controller"
application.register("consultant-form", ConsultantFormController)

import DatahubMembershipController from "./datahub_membership_controller"
application.register("datahub-membership", DatahubMembershipController)

import DatahubTeamController from "./datahub_team_controller"
application.register("datahub-team", DatahubTeamController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DatatableFilecabinetController from "./datatable_filecabinet_controller"
application.register("datatable-filecabinet", DatatableFilecabinetController)

import DetailedReportDatatableController from "./detailed_report_datatable_controller"
application.register("detailed-report-datatable", DetailedReportDatatableController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DropdownSearchController from "./dropdown_search_controller"
application.register("dropdown-search", DropdownSearchController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FormController from "./form_controller"
application.register("form", FormController)

import HpaDatatableController from "./hpa_datatable_controller"
application.register("hpa-datatable", HpaDatatableController)

import HsDocumentFileController from "./hs_document_file_controller"
application.register("hs-document-file", HsDocumentFileController)

import LicencesController from "./licences_controller"
application.register("licences", LicencesController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import SimpleSearchController from "./simple_search_controller"
application.register("simple-search", SimpleSearchController)

import TeamsDatatableController from "./teams_datatable_controller"
application.register("teams-datatable", TeamsDatatableController)

import TimepickerController from "./timepicker_controller"
application.register("timepicker", TimepickerController)

import VideoController from "./video_controller"
application.register("video", VideoController)
